import EventSystem from './EventSystem'

const GlobalEvents = new EventSystem()

export default GlobalEvents

export {EventSystem}
